export default {
  baseUrl: 'https://calmos.test-api.afelog.xyz/api',
  notificatorUrl: 'https://localhost:8000',
};
